<template>
  <template v-if="enableStatusChange">
    <div
      v-tooltip="currentStatus?.name"
      class="
        sf-btn
        tw-max-w-[200px]
        tw-text-ellipsis
        tw-overflow-hidden
        tw-whitespace-nowrap
        tw-block
      "
      data-testid="change-workflow-status-button"
      @click="openWorkflowStatusChangeForm"
    >
      <i class="icon icon-pencil tw-mr-1"></i>
      {{ I18n.t('workflow_statuses.actions.status') }}:
      {{ currentStatus?.name }}
    </div>
    <workflow-status-change-form
      :workflow-id="workflowId"
      :workflow-status-id="currentWorkflowStatusId"
      :workflow-statuses="workflowStatuses"
      :workflow-name="workflowName"
      :workflow-status-change-form-visible="workflowStatusChangeFormVisible"
      @closeWorkflowStatusChangeForm="closeWorkflowStatusChangeForm"
      @setStatusAndHideForm="setStatusAndHideForm"
    />
  </template>
  <template v-else>
    <div
      class="sf-font-s sf-font-normal workflow-status__container"
      data-testid="workflow-status-label"
    >
      <span
        v-if="currentStatus"
        class="
          sf-label sf-label-rectangular
          workflow-status__label
          sf-c-text-darker
        "
        :class="statusChangeButtonClass"
      >
        {{ currentStatus.name }}
      </span>
    </div>
  </template>
</template>

<script>
import WorkflowStatusChangeForm from './workflow-status-change-form'

const WorkflowStatus = {
  name: 'WorkflowStatus',
  components: { WorkflowStatusChangeForm },
  props: {
    enableStatusChange: {
      type: Boolean,
      default: false,
    },
    workflowId: {
      type: Number,
      required: true,
    },
    workflowStatusId: {
      type: Number,
      required: false,
      default: null,
    },
    workflowName: {
      type: String,
      required: true,
    },
    workflowStatuses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      workflowStatusChangeFormVisible: false,
      currentWorkflowStatusId: this.workflowStatusId,
      changeStatusMessage: () =>
        this.currentWorkflowStatusId
          ? I18n.t('workflow_statuses.actions.change_status')
          : I18n.t('workflow_statuses.actions.select_status'),
    }
  },
  computed: {
    currentStatus() {
      return this.workflowStatuses.find(
        (x) => x.id === parseInt(this.currentWorkflowStatusId)
      )
    },
    statusChangeButtonClass() {
      return {
        'workflow-status__label--attached':
          this.enableStatusChange && this.currentStatus,
      }
    },
  },
  methods: {
    openWorkflowStatusChangeForm() {
      this.workflowStatusChangeFormVisible = true
    },
    closeWorkflowStatusChangeForm() {
      this.workflowStatusChangeFormVisible = false
    },
    setStatusAndHideForm(status) {
      this.workflowStatusChangeFormVisible = false
      this.currentWorkflowStatusId = status
    },
  },
}

export default WorkflowStatus
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.workflow-status {
  &__label {
    border-color: -color('snow', 'darker');

    &--attached {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }
  }

  &__container {
    display: inline-flex;
  }

  &__button {
    border-color: -color('snow', 'darker');
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
